class CopyLink extends HTMLElement {
  constructor() {
    super();
    this.handleClick = this.handleClick.bind(this);
  }
  connectedCallback() {
    this.href = this.getAttribute("href");
    this.addEventListener("click", this.handleClick);
  }
  handleClick(e) {
    e.preventDefault();
    if (!navigator.clipboard) return;
    navigator.clipboard.writeText(this.href);
  }
  disconnectedCallback() {
    this.removeEventListener("click", this.handleClick);
  }
}
if (!customElements.get("copy-link")) {
  customElements.define("copy-link", CopyLink);
}
